import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureStatusErrorComponent } from './feature-status-error.component';

@NgModule({
  declarations: [FeatureStatusErrorComponent],
  exports: [FeatureStatusErrorComponent],
  imports: [CommonModule]
})
export class FeatureStatusErrorModule {}
